import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'accept-booking-modal',
    ];

    static values = {
        bookingId: Number,
    };

    openModal(event) {
        if (event) {
            event.preventDefault();
        }

        this.acceptBookingModalOutlet.bookingIdValue = this.bookingIdValue;
        this.acceptBookingModalOutlet.showContent();
    }
}
